import { render, staticRenderFns } from "./Votos.vue?vue&type=template&id=c08d9904&scoped=true"
import script from "./Votos.vue?vue&type=script&lang=js"
export * from "./Votos.vue?vue&type=script&lang=js"
import style0 from "./Votos.vue?vue&type=style&index=0&id=c08d9904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d9904",
  null
  
)

export default component.exports